import React, { useMemo, memo } from "react";
import styles from "./Loader.module.css";

interface LoaderProps {
  className?: string;
  size?: "sm" | "md" | "lg";
  variant?: "border" | "grow";
  color?: string;
}

const Loader: React.FC<LoaderProps> = ({
  className = "",
  size = "sm",
  variant = "border",
  color,
}) => {
  const sizeClasses = useMemo(() => ({
    sm: variant === "border" ? "spinner-border-sm" : "spinner-grow-sm",
    md: "",
    lg: variant === "border" ? "spinner-border-lg" : "spinner-grow-lg",
  }), [variant]);

  const sizeModuleClasses = useMemo(() => ({
    sm: styles.loaderSm,
    md: styles.loaderMd,
    lg: styles.loaderLg,
  }), []);

  const animationClass = useMemo(() => variant === "border" ? styles.borderAnimation : styles.growAnimation, [variant]);
  const spinnerClass = useMemo(() => variant === "border" ? "spinner-border" : "spinner-grow", [variant]);
  const sizeClass = useMemo(() => sizeClasses[size], [sizeClasses, size]);

  const colorClass = useMemo(() => color ? styles.customColor : "", [color]);
  const colorVars = useMemo(() => color ? ({ "--loader-color": color } as React.CSSProperties) : undefined, [color]);

  return (
    <span
      className={`${spinnerClass} ${sizeClass} ${sizeModuleClasses[size]} ${animationClass} ${colorClass} ${className}`.trim()}
      role="status"
      aria-hidden="true"
      style={colorVars}
    >
      <span className="visually-hidden">Loading...</span>
    </span>
  );
};

export default memo(Loader);
